import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, ArrowRight, ArrowUpRight } from 'lucide-react';
import { Button } from './ui/button';
import { api } from '../lib/api';
import { withRef } from '../lib/affiliate';
import { getOffer } from '../lib/offers';

// The main product offer (FE / Creator), shown on the landing and pricing pages.
export default function FeOffer() {
  const navigate = useNavigate();
  const [config, setConfig] = useState({});
  useEffect(() => { api.publicConfig().then(setConfig).catch(() => {}); }, []);
  const offer = getOffer('fe', config);
  const link = (config.buy_links || {}).fe;
  if (!offer) return null;

  return (
    <div className="mx-auto max-w-xl rounded-2xl border border-node-style/50 bg-node-style/[0.06] p-8" data-testid="fe-offer">
      <span className="rounded-full bg-node-style px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-black">The Idolaris license</span>
      <div className="mt-4 flex items-baseline justify-between">
        <h3 className="text-xl font-semibold text-white">{offer.name}</h3>
        <div className="flex items-baseline gap-1.5">
          <span className="font-serif-display text-4xl text-white">{offer.price}</span>
          <span className="text-xs text-muted-foreground">{offer.cadence}</span>
        </div>
      </div>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{offer.tagline}</p>
      <ul className="mt-5 space-y-2.5">
        {offer.features.map((f) => (
          <li key={f} className="flex items-start gap-2 text-sm text-white/80">
            <Check size={15} className="mt-0.5 shrink-0 text-node-environment" />{f}
          </li>
        ))}
      </ul>
      <div className="mt-7 flex flex-col gap-2.5 sm:flex-row">
        <Button onClick={() => navigate('/register')} data-testid="fe-start-free" className="group h-11 flex-1 rounded-full bg-white text-sm font-medium text-black hover:bg-white/90">
          Start creating free <ArrowRight size={15} className="ml-1.5 transition-transform group-hover:translate-x-0.5" />
        </Button>
        {link && (
          <button onClick={() => window.open(withRef(link), '_blank', 'noopener')} data-testid="fe-buy" className="inline-flex h-11 flex-1 items-center justify-center gap-1.5 rounded-full border border-white/20 bg-white/5 text-sm font-medium text-white transition-colors hover:bg-white/10">
            Get {offer.name} {offer.price} <ArrowUpRight size={15} />
          </button>
        )}
      </div>
      <p className="mt-4 text-center text-xs text-white/40">150 free credits &middot; No card required &middot; Bring your own keys</p>
    </div>
  );
}
